import React from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import DateField from '../fields/DateField';
import NavRow from '../fields/NavRow';
import { TaskDefinition, TaskStepRenderArgs } from '../QuestionnaireShell';
import { PracticeStartValues } from '../types';
import { zodResolver } from '../validation';

const schema = z.object({
  startDate: z.string().min(1, 'Start Date is required'),
});

const DEFAULTS: PracticeStartValues = { startDate: '' };

const PracticeStartForm = ({ initialValues, onComplete, onBack, onCancelEdit, submitLabel }: TaskStepRenderArgs) => {
  const defaults = (initialValues as PracticeStartValues | undefined) ?? DEFAULTS;
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<PracticeStartValues>({
    defaultValues: defaults,
    resolver: zodResolver(schema),
    mode: 'onChange',
  });

  const onSubmit = handleSubmit((values) => onComplete(values));

  return (
    <form className="rnq-form" onSubmit={(e) => e.preventDefault()}>
      <DateField control={control} name="startDate" label="Start Date" required disableFuture />
      <NavRow
        onBack={onBack}
        onCancelEdit={onCancelEdit}
        onSubmit={onSubmit}
        submitLabel={submitLabel}
        disabled={!isValid}
      />
    </form>
  );
};

const PracticeStart: TaskDefinition = {
  key: 'task4',
  label: 'Practice Start',
  title: 'When did you begin practicing law?',
  render: (args) => <PracticeStartForm {...args} />,
};

export default PracticeStart;
